"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _Dialog = _interopRequireDefault(require("@mui/material/Dialog"));

var _DialogContent = _interopRequireDefault(require("@mui/material/DialogContent"));

var _Divider = _interopRequireDefault(require("@mui/material/Divider"));

var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress"));

var _styles = require("@mui/material/styles");

var _IconButton = _interopRequireDefault(require("../IconButton/IconButton"));

var _Form = _interopRequireDefault(require("../Form/Form"));

var _TextButton = _interopRequireDefault(require("../TextButton/TextButton"));

var _Typography = _interopRequireDefault(require("../Typography/Typography"));

var _Announcer = _interopRequireDefault(require("./Announcer"));

var _DeleteDialog = _interopRequireWildcard(require("./DeleteDialog"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var FormContainer = (0, _styles.styled)("div")(function () {
  return "\n  position: relative;\n  &.loading {\n    & form {\n      opacity: 0;\n    }\n  }\n";
});
var LoadingContainer = (0, _styles.styled)("div")(function () {
  return "\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n";
});

var EditDialog = function EditDialog(_ref) {
  var object = _ref.object,
      open = _ref.open,
      toggle = _ref.toggle,
      labels = _ref.labels,
      onDelete = _ref.onDelete,
      onSubmit = _ref.onSubmit,
      loading = _ref.loading,
      canManageOptions = _ref.canManageOptions,
      errors = _ref.errors;

  var _useState = (0, _react.useState)(object),
      _useState2 = (0, _slicedToArray2.default)(_useState, 1),
      initialValues = _useState2[0];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      showDelete = _useState4[0],
      setShowDelete = _useState4[1];

  var onClose = function onClose(_event, reason) {
    // Only close when close icon is pressed or escape
    if (reason === "backdropClick") {
      return;
    }

    toggle();
  };

  var toggleDelete = function toggleDelete() {
    setShowDelete(function (prev) {
      return !prev;
    });
  };

  var errorProps = (0, _react.useMemo)(function () {
    if (!errors.update && !errors.delete) {
      return {};
    }

    return {
      error: !!errors.update || !!errors.delete,
      helperText: errors.update || errors.delete
    };
  }, [errors]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Dialog.default, {
      open: open,
      onClose: onClose,
      maxWidth: "md",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(FormContainer, _objectSpread(_objectSpread({}, loading ? {
        className: "loading"
      } : {}), {}, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Announcer.default, {
          message: loading ? labels.updating : ""
        }), loading && /*#__PURE__*/(0, _jsxRuntime.jsxs)(LoadingContainer, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CircularProgress.default, {
            thickness: 5
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
            component: "p",
            children: labels.updating
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Form.default, {
          initialValues: initialValues,
          onSubmit: onSubmit,
          children: function children(_ref2) {
            var _form$getState, _form$getState$values;

            var form = _ref2.form,
                handleSubmit = _ref2.handleSubmit,
                data = _ref2.values;
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
              noValidate: true,
              onReset: form.reset,
              onSubmit: handleSubmit,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_DeleteDialog.StyledDilogTitle, {
                children: [labels.editTitle, /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
                  iconName: "times",
                  iconStyle: "fas",
                  size: "large",
                  "aria-label": labels.iconClose,
                  borderless: true,
                  onClick: toggle,
                  sx: {
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: function color(theme) {
                      return theme.palette.grey[600];
                    }
                  }
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DialogContent.default, {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DeleteDialog.StyledDialogContentText, {
                  children: labels.editDescription
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Form.default.TextField, _objectSpread({
                  readOnly: false,
                  disabled: false,
                  margin: "dense",
                  id: "name",
                  fullWidth: true,
                  required: true,
                  name: "label",
                  value: data.label,
                  placeholder: labels.editPlaceholder,
                  variant: "standard"
                }, errorProps))]
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DeleteDialog.StyledDialogActions, {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TextButton.default, {
                  onClick: toggleDelete,
                  variant: "outlined",
                  label: labels.buttonDelete
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextButton.default, {
                  variant: "contained",
                  label: labels.buttonUpdate,
                  type: "submit",
                  disabled: form.getState().pristine || !((_form$getState = form.getState()) !== null && _form$getState !== void 0 && (_form$getState$values = _form$getState.values) !== null && _form$getState$values !== void 0 && _form$getState$values.label) || !canManageOptions
                })]
              })]
            });
          }
        })]
      }))
    }), showDelete && /*#__PURE__*/(0, _jsxRuntime.jsx)(_DeleteDialog.default, {
      labels: labels,
      onAccept: function onAccept() {
        toggleDelete();
        onDelete(object);
      },
      canManageOptions: canManageOptions,
      onCancel: toggleDelete,
      open: showDelete,
      toggle: toggleDelete
    })]
  });
};

var _default = EditDialog;
exports.default = _default;